module.exports = __webpack_public_path__ + "img/ic_next_step.3b6b65a7.svg";